// extracted by mini-css-extract-plugin
export default {"container":"About_container__it7J3","imgContainer":"About_imgContainer__F-HqY","img":"About_img__zMRZM","text":"About_text__3LTXJ"};